/**
 * Shared horizontal gutter for My bookings content sections.
 * Uses a CSS class (see index.css) — Tailwind `md:px-*` utilities are unreliable here.
 */
export const BOOKINGS_CONTENT_GUTTER = 'bookings-content-gutter'
